import React, { useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  TextField,
} from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import { useVerifyCode } from "rest";
import { useProfile } from "context";
import { useTranslation } from "react-i18next";

interface IFormInput {
  code: String;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formContents: {
      width: "-webkit-fill-available",
      paddingBottom: "11px",
    },
  })
);

export const VerifyCodeDialog = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { handleSubmit, register, errors, getValues } = useForm<IFormInput>();

  const {
    setVerifyData,
    setActiveStep,
    setVerifyCode,
    verifyCodeStatus,
    setVerifyCodeStatus,
    setFullScreen,
    setChecked,
  } = useProfile();

  const [open, setOpen] = useState(false);
  const [errorText, setErrorText] = useState("");

  const { refetch: getVerifyCode } = useVerifyCode(
    {
      code: getValues("code") as string,
    },
    {
      enabled: false,
      onSuccess: (results) => {
        checkMessage(results);
        setVerifyData(results);
        if (results.vehicleMatch) {
          setActiveStep(1);
        }
        setVerifyCode(getValues("code") as string);
      },
      onError: (error) => {
        console.error(error);
      },
    }
  );

  const onSubmitX: SubmitHandler<IFormInput> = () => {
    getVerifyCode();
  };

  const checkMessage = (data) => {
    switch (data.message) {
      case "Success!":
        setErrorText(t("success"));
        setVerifyCodeStatus(false);
        setChecked(true);
        setTimeout(() => {
          setChecked(false);
        }, 5000);
        break;
      case "Error! Vehicle platenumber does not match":
        setErrorText(t("error_vehicle_plate_number_not_match"));
        setVerifyCodeStatus(false);
        setOpen(true);
        break;
      case "Error! No vehicle found":
        setErrorText(t("error_no_vehicle_found"));
        setOpen(true);
        setVerifyCodeStatus(false);
        break;
      case "Error! Phone Number belongs to another account.":
        setErrorText(t("error_phone_belong_another_acc"));
        setOpen(true);
        setVerifyCodeStatus(false);
        break;
      case "Error! Invalid Code":
        setErrorText(t("error_invalid_code"));
        setOpen(true);
        break;
      case "":
        setVerifyCodeStatus(false);
        setFullScreen(true);
        break;
      case "Error! There is a problem with travelers":
        setVerifyCodeStatus(false);
        setErrorText(t("error_traveler_problem"));
        setFullScreen(true);
        break;

      default:
        setErrorText(t("error_sync_failed"));
        setOpen(true);
        setVerifyCodeStatus(false);
        break;
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Achtung"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{errorText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary" autoFocus>
            {t("label_ok")}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={verifyCodeStatus}
        onClose={() => setVerifyCodeStatus(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{t("check_mobile_number")}</DialogTitle>

        <form onSubmit={handleSubmit(onSubmitX)}>
          <DialogContentText style={{ marginLeft: "25px" }}>{t("for_sync_enter_sms_code")}</DialogContentText>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <TextField
                  name="code"
                  variant="outlined"
                  label={t("code")}
                  required
                  error={errors.code ? true : false}
                  inputRef={register({
                    required: true,
                    pattern: /^[0-9]*$/i,
                    minLength: {
                      value: 6,
                      message: "min length is 6",
                    },
                  })}
                  className={classes.formContents}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setVerifyCodeStatus(false)} color="primary">
              {t("label_cancel")}
            </Button>
            <Button variant="contained" color="primary" disableElevation type="submit">
              {t("verify")}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};
